import { companyInfo } from "@/config/constants";
import { ResetPasswordForm } from "@/modules/authentication/components/reset-form";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { LeftPanel } from "../components/left-panel";

export default function ResetPasswordPage() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2 bg-[#F7F7F7]">
      {/* Left Panel - Security and Success */}
      <LeftPanel />

      {/* Right Panel - Reset Password Form */}
      <div className="flex flex-col gap-4 p-6 md:p-10 lg:p-12">
        {/* Back to Login */}
        <div className="flex items-center gap-2 mb-4">
          <Link
            to="/login"
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Quay lại đăng nhập
          </Link>
        </div>
        {/* Mobile Header */}
        <div className="flex justify-center gap-2 lg:hidden mt-12">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 border border-gray-300 bg-white rounded-lg flex items-center justify-center">
              <img src="/icon.png" alt="logo" className="w-10 h-10" />
            </div>
            <div>
              <div className="flex items-end">
                <h1 className="text-2xl font-bold text-primary">
                  {companyInfo.shortName}
                </h1>
                <span>meeting</span>
              </div>
              <p className="text-xs text-gray-500">{companyInfo.description}</p>
            </div>
          </div>
        </div>

        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-md">
            <ResetPasswordForm />
          </div>
        </div>
      </div>
    </div>
  );
}
